import { IBaseEntity } from './base';

export interface ISession extends IBaseEntity {
  userId: number;
  ip: number;
  jwtToken: number;
}

export interface ISessionAttempt extends IBaseEntity {
  sessionId: number;
  organisationUserId: number;
  moduleId: number;
  courseProgressId: number;
  status: SessionAttemptStatus;
  statsProgress: number;
  statsTime: number;
}

export interface ISessionAttemptDAO extends ISessionAttempt {
  sessionActions: ISessionAction[];
}

export enum SessionAttemptStatus {
  DELETED = 1,
  NEW = 0,
  ACTIVE = 1,
  COMPLETE = 2,
  ARCHIVED = 3,
}

export interface ISessionAction extends IBaseEntity {
  sessionAttemptId: number;
  actionId: number;
  status: SessionActionStatus;
}

export interface ISessionActionDAO extends ISessionAction {
  sessionActionEntities: ISessionActionEntity[];
}

export enum SessionActionStatus {
  FAILED = -1,
  PASSED = 0,
}

export interface ISessionActionEntity extends IBaseEntity {
  sessionActionId: number;
  actionEntityId: number;
  status: SessionActionEntityStatus;
}

export enum SessionActionEntityStatus {
  UNSELECTED = -1,
  SELECTED = 0,
}

export interface ISessionResource extends IBaseEntity {
  sessionAttemptId: number;
  resourceInstanceId: number;
  courseProgressId: number;
  systemPermissionId: number;
  status: SessionResourceStatus;
}

export enum SessionResourceStatus {
  FAILED = -1,
  PASSED = 0,
}

export interface ISessionVariable extends IBaseEntity {
  sessionAttemptId: number;
  variableId: number;
  value: number;
}
